import './ui.css';

export type StatusTone = 'neutral' | 'success' | 'warning' | 'danger' | 'info';

interface StatusPillProps {
  label: string;
  tone?: StatusTone;
}

/**
 * Status is carried by the label text, not only by the tone color, so meaning
 * never depends on color alone.
 */
export function StatusPill({ label, tone = 'neutral' }: StatusPillProps) {
  return <span className={`ui-pill ui-pill--${tone}`}>{label}</span>;
}
